// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1NR5b","inputWrap":"styles_inputWrap__Qsfcm","input":"styles_input__SRsMY"};